import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import PageHeader from '../common/PageHeader';
import './Sounds.css';

interface SoundsProps {
  onToggleSidebar: () => void;
  onClose: () => void;
}

interface SoundItem {
  id: string;
  title: string;
  videoId: string;
  embedUrl: string;
}

const Sounds: React.FC<SoundsProps> = ({ onToggleSidebar, onClose }) => {
  const { user, loading: authLoading } = useAuth();
  
  // Initial sound data
  const [sounds] = useState<SoundItem[]>([
    {
      id: '1',
      title: 'Sound 1',
      videoId: 'ArwcHjmsw3A',
      embedUrl: 'https://www.youtube.com/embed/ArwcHjmsw3A?si=30cD3mEub4JGo7ph'
    },
    {
      id: '2',
      title: 'Sound 2',
      videoId: 'ob0hXXPLfmU',
      embedUrl: 'https://www.youtube.com/embed/ob0hXXPLfmU?si=svXlvCTxHqxpKqhk'
    }
  ]);

  // Show loading state while checking authentication
  if (authLoading) {
    return (
      <div className="sounds-container">
        <div className="sounds-header">
          <h1 className="sounds-title">/sounds</h1>
          <p className="sounds-subtitle">Loading...</p>
        </div>
      </div>
    );
  }

  // Show message if user is not authenticated
  if (!user) {
    return (
      <div className="sounds-container">
        <div className="sounds-header">
          <h1 className="sounds-title">/sounds</h1>
          <p className="sounds-subtitle">Please sign in to access sounds</p>
        </div>
        <div className="empty-state">
          <p>Authentication required to access sounds</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sounds-container">
      <PageHeader
        onToggleSidebar={onToggleSidebar}
        centerContent={<h1 className="page-header-center-title">/sounds</h1>}
      />
      
      <div className="sounds-content">
        <div className="sounds-header">
          <p className="sounds-subtitle">YouTube video sounds</p>
        </div>

        {sounds.length === 0 ? (
          <div className="empty-state">
            <p>No sounds available</p>
          </div>
        ) : (
          <div className="sounds-grid">
            {sounds.map((sound) => (
              <div key={sound.id} className="sound-card">
                <div className="sound-iframe-wrapper">
                  <iframe
                    width="560"
                    height="315"
                    src={sound.embedUrl}
                    title={sound.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="sound-iframe"
                  />
                </div>
                <div className="sound-info">
                  <p className="sound-title">{sound.title}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Sounds;

